import { render } from "./ObjectSettingsDataAccess.vue?vue&type=template&id=3c7db5cb"
import script from "./ObjectSettingsDataAccess.vue?vue&type=script&lang=js"
export * from "./ObjectSettingsDataAccess.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.25.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__